<template>
        <div class="flex flex-col rounded-2xl p-4 bg-white border border-gray-500 max-w-[20.8rem]">
            <div>
                <h1 class="text-primary font-bold text-center">Filtros</h1>
                <div class="flex flex-col gap-y-4">
                    <ExpandableRadio
                        :enable="false"
                        title="Campanha"
                        class="max-w-[350px]"
                        :options="[{name: currentContest.name, value: currentContest.name}]"
                        :initialValue="{name: currentContest.name, value: currentContest.name}"
                    />
                    <div
                    >
                    <ExpandableCheckbox
                    ref="regionSelect"
                    :options="computedRegions"
                    enable
                    v-if="canSelectMultiplesRegions"
                    title="Regional"
                    placeholder="Selecione uma ou mais regiões"
                    class="max-w-[19rem] z-10"
                    @click="onRegionInteract"
                    @focus="onRegionInteract"
                    @updateValue="formFilter.regions = $event"
                    :modelValue="formFilter.regions"
                    />

                    <ExpandableRadio
                    ref="regionSelect"
                    v-else
                    :options="computedRegions"
                    title="Regional"
                    placeholder="Selecione uma ou mais regiões"
                    class="max-w-[19rem] z-10"
                    @click="onRegionInteract"
                    @focus="onRegionInteract"
                    @updateValue="formFilter.regions = $event"
                    :modelValue="formFilter.regions"
                    />
                        <label v-if="canSelectMultiplesRegions">
                            <input
                                class="mt-6 mb-2"
                                type="checkbox"
                                :value="true"
                                :onclick="() => (formFilter[1].value = true)"
                                v-model="formFilter.regions"
                            />
                            Marcar todas
                        </label>
                    </div>
                    <div>
                        <SearchableExpandableCheckbox
                            v-if="canSelectMultiplesSubregions"
                            :options="computedSubregions"
                            title="Sub-Regional"
                            placeholder="Selecione as sub-regionais"
                            class="max-w-[19rem]"
                            @updateValue="formFilter.subregions = $event"
                            :initialValue="formFilter.subregions"
                        />
                        <SearchableExpandableRadio
                            v-else
                            :options="computedSubregions"
                            title="Sub-Regional"
                            placeholder="Selecione as sub-regionais"
                            class="max-w-[19rem]"
                            @updateValue="formFilter.subregions = $event"
                            :modelValue="formFilter.subregions"
                        />
                        <label v-if="canSelectMultiplesSubregions">
                           <input
                            class="mb-2"
                            type="checkbox"
                            :checked="isAllSubregionsSelected"
                            @change="toggleAllSubregions"
                        />
                            Marcar todas
                        </label>
                    </div>
                    <div>
                        <ExpandableRadio
                            :options="computedCategories"
                            title="Categoria"
                            placeholder="Selecione uma categoria"
                            class="max-w-[19rem]"
                            @updateValue="formFilter.category = $event"
                            v-model="formFilter.category"
                        />
                        <label>
                            <input
                                class="mb-2"
                                type="checkbox"
                                :value="true"
                                :onclick="() => (formFilter.category = true)"
                                v-model="formFilter.category"
                            />
                            Marcar todas
                        </label>
                    </div>
                    <div>
                        <ExpandableRadio
                            :options="computedPdvChannels"
                            title="Canal"
                            placeholder="Selecione um canal"
                            class="max-w-[19rem]"
                            @updateValue="formFilter.pdvChannel = $event"
                            :clear="cleaningForm"
                        />
                        <label>
                            <input
                                class="mb-2"
                                type="checkbox"
                                :value="true"
                                :onclick="() => (formFilter.pdvChannel = true)"
                                v-model="formFilter.pdvChannel"
                            />
                            Marcar todas
                        </label>
                    </div>

                    <div>
                        <ExpandableRadio
                            :options="computedExecutions"
                            title="Execuções"
                            placeholder="Selecione uma ou mais execuções"
                            class="max-w-[19rem]"
                            @updateValue="formFilter.executionType = $event"
                            :clear="cleaningForm"
                        />
                        <label>
                            <input
                                class="mb-2"
                                type="checkbox"
                                :value="true"
                                :onclick="() => (formFilter.executionType = true)"
                                v-model="formFilter.executionType"
                            />
                            Marcar todas
                        </label>
                    </div>

                    <div>
                        <ExpandableRadio
                            :options="computedGalleryStatus"
                            title="Selecionadas"
                            placeholder="Selecione um status"
                            class="max-w-[19rem]"
                            @updateValue="formFilter.status = $event"
                            :clear="cleaningForm"
                        />
                    </div>
                    <AutocompleteNameSAP
                        :participants="participants"
                        title="Participante"
                        placeholder="Selecione um participante"
                        :enable="true"
                        @updateValue="formFilter.participantId = $event.id"
                    />
                    <StoreFilter
                        :options="{ clearWhenUpdateItems: true }"
                        :items="computedStores"
                        title="Sold"
                        class="max-w-[300px]"
                        @update-value="handleSoldUpdate($event)"
                    />
                    <div class="flex flex-col items-center">
                        <div>
                            <Button
                                :enabled="allIsValid"
                                @click.prevent="sendSpecificFilter"
                                class="bg-primary !text-white p-4">
                                Aplicar Filtros
                            </Button>
                        </div>
                        <div>
                            <button
                                @click.prevent="clearFilter"
                                class="text-primary text-xs hover:underline"
                            >
                                Limpar Filtros
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <transition v-if="showRegionModal" appear>
                <div class="fixed inset-0 z-[99] bg-black bg-opacity-30 flex justify-center items-center px-5">
                    <div class="bg-white border border-gray-200 rounded-2xl max-w-[360px] w-full px-5 py-6 relative shadow-lg">
                    <h1 class="text-primary font-bold text-lg text-left">Alteração de Região</h1>

                    <button class="absolute right-2 top-2" @click="closeRegionModal">
                        <Icon name="Fechar" />
                    </button>

                    <p class="mt-4 text-left text-sm text-gray-700 leading-relaxed">
                        ⚠️ Ao alterar a <strong>Regional</strong>, você será redirecionado para a etapa de
                        <strong>pré-filtro</strong> da campanha.
                        <br />
                        Deseja realmente continuar?
                    </p>

                    <div class="flex justify-left gap-3 mt-6">
                        <Button class="px-4 py-2 border border-gray-400 text-gray-700 rounded-md"
                                @click="closeRegionModal">
                        Cancelar
                        </Button>

                        <Button class="bg-primary !text-white px-4 py-2 rounded-md"
                                @click="confirmRegionChange">
                        Confirmar
                        </Button>
                    </div>
                    </div>
                </div>
            </transition>
        </div>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import ExpandableRadio from "@/Components/ExpandableRadio.vue";
import ExpandableCheckbox from "@/Components/ExpandableCheckbox.vue";
import SearchableExpandableRadio from "@/Components/SearchableExpandableRadio.vue";
import SearchableExpandableCheckbox from "@/Components/SearchableExpandableCheckbox.vue";
import AutocompleteNameSAP from "@/Components/AutocompleteNameSAP.vue";
import StoreFilter from "@/Components/StoreFilter.vue";
import Input from "@/Components/UI/Form/Input.vue";

export default {
    components: {
        Head,
        Head,
        Icon,
        Button,
        ExpandableRadio,
        ExpandableCheckbox,
        SearchableExpandableRadio,
        SearchableExpandableCheckbox,
        Input,
        AutocompleteNameSAP,
        StoreFilter,
    },

    props: {
        currentContest: Object,
        regions: Object,
        subregions: Object,
        pdvChannels: Object,
        preFilterData: Object,
        participants: {
            type: Object,
            default: [],
        },
        stores: {
            type: Object,
            default: []
        },
    },

    emits: ["updateFilter", "clearFilter"],

    data() {
        return {
            currentGallery: "",
            showModalChangePoints: false,
            title: "-",
            currentInput: "",
            showSelectRegions: false,
            formFilter: this.$inertia.form({
                regions: [],
                subregions: [],
                category: "",
                pdvChannel: "",
                executionType: "",
                status: "",
                participantId: "",
                store: "",
                storeLike: "",
            }),
            cleaningForm: false,
            showRegionModal: false,
        };
    },

    watch: {
        preFilterData(newValue) {
            this.clearFilter();
        }
    },

    computed: {
        isAllSubregionsSelected() {
            const selected = this.formFilter.subregions;
            const allOptions = this.computedSubregions;

            if (selected === true) return true;
            if (Array.isArray(selected) && allOptions?.length) {
            return selected.length === allOptions.length;
            }
            return false;
        },
        contestsAvailableToVote() {
            return this.$page.props.auth.user.contestJudges;
        },
        canSelectMultiplesRegions() {
            const contest = this.currentContest;

            const isNationalStage =
                contest?.stage === 3 && contest?.winningType === "N";
            const isNationalPodium =
                contest?.stage === 4 && contest?.podiumType === "N";

            return isNationalStage || isNationalPodium;
        },
        canSelectMultiplesSubregions() {
            const contest = this.currentContest;
            const contestStage = this.fetchRegionStatus;

            const isRegionalOrNationalStage =
                contestStage > 1 &&
                contestStage < 4 &&
                ["N", "R"].find((el) => el == contest?.winningType);
            const isRegionalOrNationalPodium =
                contestStage === 4 &&
                ["N", "R"].find((el) => el == contest?.podiumType);

            return isRegionalOrNationalStage || isRegionalOrNationalPodium;
        },
        fetchRegionStatus() {
            let regions = this.formFilter.regions;
            const contest = this.currentContest;

            const isNationalStage =
                contest?.stage === 3 && contest?.winningType === "N";
            const isNationalPodium =
                contest?.stage === 4 && contest?.podiumType === "N";

            if (isNationalStage || isNationalPodium) {
                return contest?.stage || 1;
            } else {
                if (regions === true || regions.length > 0 || regions?.id) {
                    if (regions === true) regions = this.computedRegions;
                    else if (regions.id) regions = [regions];
                    const region = regions?.length > 0 && regions[0];

                    return (
                        contest?.stage > region?.contestRegionStage
                            ? contest?.stage
                            : region?.contestRegionStage
                    ) || 1;
                } else {
                    return contest?.stage || 1;
                }
            }
        },
        computedRegions() {
            const avaibleContests = this.contestsAvailableToVote;
            const contestStage = this.currentContest?.stage || 1;
            const contestRegionStages = this.currentContest?.regionsStage;

            const hasNationalStage = this.currentContest?.winningType === "N";
            const hasNationalPodium = this.currentContest?.podiumType === "N";

            const regionWithStage = this.regions
                .map((region) => {
                    const { id, name } = region;

                    const contestRegionStage = contestRegionStages?.find(
                        ({ regionId: contestRegionStageRegionId }) => {
                            return region.id === contestRegionStageRegionId;
                        }
                    );

                    return {
                        id,
                        name,
                        contestRegionStage: contestRegionStage?.stage || 1,
                    };
                });

            return regionWithStage?.filter((region) => {
                const { contestRegionStage } = region;

                if(hasNationalStage && contestRegionStage === 3 && contestStage < 3) return false;
                if(hasNationalPodium && contestRegionStage === 4 && contestStage < 4) return false;

                const regionStageGreaterThanContestLimit =
                    this.currentContest?.hasPodium
                        ? contestRegionStage > 4
                        : contestRegionStage > 3;

                const regionStageAllowed = avaibleContests.find(
                    (b) =>
                        this.currentContest?.id == b.contestId &&
                        b.stage == contestRegionStage
                );

                if (
                    contestStage > contestRegionStage ||
                    regionStageGreaterThanContestLimit ||
                    !regionStageAllowed
                ) {
                    return false;
                } else {
                    return true;
                }
            });
        },
        computedSubregions() {
            let regions = this.formFilter.regions;
            const contestStage = this.currentContest?.stage || 1;
            const contestSubRegionStages = this.currentContest?.regionsStage;

            const subregionWithStage = this.subregions
                .map((subregion) => {
                    const { id, name, regionId } = subregion;

                    const contestSubregionStage = contestSubRegionStages?.find(
                            ({ subregionId: stageSubregionId }) => {
                                return subregion.id == stageSubregionId;
                            }
                        );

                    return {
                        id,
                        name,
                        regionId,
                        contestSubregionStage: contestSubregionStage?.stage || 1,
                    };
                });

            const filteredSubegionWithStage = subregionWithStage?.filter((subregion) => {
                    const { contestSubregionStage } = subregion;

                    const subregionStageGreaterThanContestLimit =
                        this.currentContest?.hasPodium
                            ? contestSubregionStage > 4
                            : contestSubregionStage > 3;

                    if ((contestStage > contestSubregionStage) || subregionStageGreaterThanContestLimit)
                        return false;
                    else return true;
                });

            if (regions === true || regions.length > 0 || regions?.id) {
                if (regions === true) regions = this.computedRegions;
                else if (regions.id) regions = [regions];

                let subregionByRegion = regions.map((region) => {
                    const contestRegionStage = region.contestRegionStage;
                    const subregionsIntoRegionStage = filteredSubegionWithStage.filter(
                        (subregion) =>
                            subregion.regionId == region.id &&
                            subregion.contestSubregionStage == contestRegionStage
                    )

                    return subregionsIntoRegionStage;
                });

                let mergedSubregions = [].concat?.apply([], subregionByRegion);

                return mergedSubregions;
            } else {
                return filteredSubegionWithStage;
            }
        },
        computedCategories() {
            return this.currentContest?.categories.map((item) => ({
                name: item.description,
                id: item.id,
            }));
        },
        computedPdvChannels() {
            let filteredChannels = this.pdvChannels;

            let regions = Object.assign(this.formFilter.regions);

            if(!Array.isArray(regions)) {
                regions = [regions];
            }

            if(regions.length) {
                regions = regions.map(el => el.id);
                filteredChannels = filteredChannels.filter(channel => regions.includes(channel.regionId));
            }

            let subregions = Object.assign(this.formFilter.subregions);

            if(!Array.isArray(subregions)) {
                regions = [subregions];
            }

            if(subregions.length) {
                subregions = subregions.map(el => el.id);
                filteredChannels = filteredChannels.filter(channel => subregions.includes(channel.subRegionId));
            }

            filteredChannels = filteredChannels.map(({canal}) => canal)

            let uniqueChannels = new Set();

            filteredChannels.forEach(el => {
                if(!uniqueChannels.has(el) && el != null) {
                    uniqueChannels.add(el);
                }
            });

            return uniqueChannels.map(el => {
                return {
                    id: el,
                    name: el,
                }
            });
        },
        computedExecutions() {
            return this.currentContest?.executionTypes.map((item) => ({
                name: item.description,
                id: item.id,
                weight: item.weight,
            }));
        },
        computedGalleryStatus() {
            return [
                {
                    id: 'Fotos Selecionadas',
                    name: 'Fotos Selecionadas'
                },
                {
                    id: 'Fotos Ocultadas',
                    name: 'Fotos Ocultadas'
                },
            ]
        },
        computedStores() {

            const formattedStores = this.stores.map(({ id, name, codeSoldBroker, canal }) => ({
                id,
                name,
                codeSoldBroker,
                canal
            }));

            if (this.formFilter.pdvChannel?.id) {
                return formattedStores.filter((el) => el.canal == this.formFilter.pdvChannel.name);
            } else {
                return formattedStores;
            }
        },
        allIsValid() {
            if(Array.isArray(this.formFilter.regions) && this.formFilter.regions.length) {
                return true;
            }

            if(!Array.isArray(this.formFilter.regions) && this.formFilter.regions) {
                return true;
            }

            return false;
        }
    },

    methods: {
        setValue(value) {
            if (this.selectList.find(item => item.id === value.id)) {
            this.selectList = this.selectList.filter(item => item.id !== value.id);
            } else {
            this.selectList.push(value);
            }

            this.$emit('updateValue', this.selectList);
        },
        close() {
        },
        confirmRegionChange() {
        this.showRegionModal = false;
        window.location.reload();
        },
        onRegionInteract() {
        this.showRegionModal = true;
        },
        closeRegionModal() {
        const comp = this.$refs.regionSelect;

        // Fecha o dropdown antes de esconder o modal
        if (comp) {
            const el = comp.$el || comp;
            const dropdown = el.querySelector('.flex.flex-col.border');

            // Fecha via classe CSS
            if (dropdown && !dropdown.classList.contains('hidden')) {
            dropdown.classList.add('hidden');
            }

            // Remove foco do botão principal (evita reabrir)
            const button = el.querySelector('button');
            if (button) button.blur();
        }

        // Agora fecha o modal normalmente
        this.showRegionModal = false;

        // Garante que o DOM finalize a transição e o foco saia completamente
        this.$nextTick(() => {
            document.activeElement?.blur();
        });
        },
        toggleAllSubregions(e) {
        if (e.target.checked) {
            this.formFilter.subregions = true;
        } else {
            this.formFilter.subregions = [];
        }
        },
        setInput(input) {
            this.currentInput = input;
        },
        sendSpecificFilter() {
            let regions = [];
            let allregions = false;
            let subregions = [];
            let allsubregions = false;
            let category = undefined;
            let pdvChannel = undefined;
            let executionType = undefined;
            let isVisible = 1;
            let isVotedOn = undefined;

            if(this.formFilter.status.name == "Fotos Ocultadas") {
                isVisible = 0;
            }

            if(this.formFilter.status.name == "Fotos Selecionadas") {
                isVotedOn = this.fetchRegionStatus;
                isVisible = null;
            }

            const selectedRegions = this.formFilter.regions;
            const selectedSubregions = this.formFilter.subregions;
            const selectedCategory = this.formFilter.category;
            const selectedPdvChannel= this.formFilter.pdvChannel;
            const selectedExecutionType = this.formFilter.executionType;

            if (selectedRegions === true) {
                regions = this.computedRegions;
                allregions = true;
            } else if (selectedRegions?.id) {
                regions = [selectedRegions];
            } else {
                regions = selectedRegions;
            }

            if (selectedSubregions === true) {
                subregions = this.computedSubregions;
                allsubregions = true;
            } else if (selectedSubregions?.id) {
                subregions = [selectedSubregions];
            } else {
                subregions = selectedSubregions;
            }

            if (selectedCategory === true) {
                category = undefined;
            } else {
                category = selectedCategory.id;
            }

            if (selectedPdvChannel === true) {
                pdvChannel = undefined;
            } else {
                pdvChannel = selectedPdvChannel.id;
            }

            if (selectedExecutionType === true) {
                executionType = undefined;
            } else {
                executionType = selectedExecutionType.id;
            }

            this.$emit("updateFilter", {
                campaign: this.currentContest.id,
                category,
                pdvChannel,
                execution: executionType,
                allregions,
                rawRegions: regions,
                regions: regions?.map((region) => region.id),
                allsubregions,
                rawSubregions: subregions,
                subregions: subregions?.map((subregion) => subregion.id),
                isVisible,
                isVotedOn,
                participantId: this.formFilter.participantId,
                store: this.formFilter.store?.id,
                storeLike: this.formFilter.storeLike,
            });
        },
        loadPdv(pdv) {
            axios
                .get(`/pdv/${pdv.id}/users`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.form.team = [];
                    this.users = data;

                    for (let i = 0; i < Object.keys(this.$refs).length; i++) {
                        if (this.$refs[`checkbox-` + i]) {
                            this.$refs[`checkbox-` + i].checked = false;
                        }
                    }
                });
        },
        clearFilter() {
            let defaultRegion = this.preFilterData.rawRegions;
            let defaultSubregions = this.preFilterData.rawSubregions;
            let defaultCategory = this.preFilterData.category;

            if(!this.canSelectMultiplesRegions && defaultRegion.length === 1) {
                defaultRegion = this.preFilterData.rawRegions[0];
            }

            if(!this.canSelectMultiplesSubregions && defaultSubregions.length === 1) {
                defaultSubregions = this.preFilterData.rawSubregions[0];
            }

            if(defaultCategory === undefined) {
                defaultCategory = true;
            } else {
                defaultCategory = this.computedCategories.find(el => el.id === defaultCategory);
            }

            this.formFilter = this.$inertia.form({
                regions: defaultRegion,
                subregions: defaultSubregions,
                category: defaultCategory,
                pdvChannel: "",
                executionType: "",
                status: "",
                participantId: "",
                store: "",
                storeLike: "",
            })

            this.cleaningForm = true;

            setTimeout(() => {
                this.cleaningForm = false;
            } , 500)

            this.$emit('clearFilter');
        },
        handleSoldUpdate($event) {
            this.formFilter.store = $event.store;
            this.formFilter.storeLike = $event.storeLike;
        },
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.no-scroll-bar::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scroll-bar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
</style>
